import React from 'react';
import { ArrowUpOutlined } from '@ant-design/icons';
import { Button } from 'antd';

function ScrollToTopButton() {
  const body = document.getElementById('scrollContainer');

  const scrollToTop = () => {
    if (body) {
      body.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  return (
    <Button
      htmlType="button"
      type="text"
      onClick={scrollToTop}
      style={{
        borderRadius: '50%', height: '52px', width: '52px', border: '1px solid #FFFFFF29',
      }}
    >
      <ArrowUpOutlined style={{ color: 'white' }} />
    </Button>
  );
}

export default ScrollToTopButton;
